module.exports = __webpack_public_path__ + "static/media/36_A.6085fd9c.png";